export default __webpack_public_path__ + "images/assets/8f17f0f0e195823a3bf5853b5b964895.svg";